import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { UserService } from 'src/app/core/services/user.service';
import { PaymentHistoryItem } from 'src/app/models/payment.interface';

@Component({
  selector: 'globot-user-payments',
  templateUrl: './user-payments.component.html',
  styleUrls: ['./user-payments.component.scss'],
})
export class UserPaymentsComponent implements OnInit {
  payments: PaymentHistoryItem[] = [];
  paymentMethodDisplay: string | null = null;
  isLoading = true;
  isDeletingPaymentMethod = false;

  constructor(
    private userService: UserService,
    private spinnerService: SpinnerService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.spinnerService.setHttpProgressStatus(true);
    let pending = 2;
    const maybeDone = () => {
      pending--;
      if (pending <= 0) {
        this.isLoading = false;
        this.spinnerService.setHttpProgressStatus(false);
      }
    };
    this.userService.getPaymentMethod().subscribe({
      next: (res) => {
        this.paymentMethodDisplay = res.display ?? null;
        maybeDone();
      },
      error: () => {
        this.paymentMethodDisplay = null;
        maybeDone();
      },
    });
    this.userService.getPaymentHistory().subscribe({
      next: (res) => {
        this.payments = res.payments ?? [];
        maybeDone();
      },
      error: () => {
        this.payments = [];
        maybeDone();
      },
    });
  }

  getStatusLabel(status: string): string {
    const labels: Record<string, string> = {
      completed: 'Pagado',
      failed: 'Fallido',
      refunded: 'Reembolsado',
      pending: 'Pendiente',
    };
    return labels[status] ?? status;
  }

  getStatusClass(status: string): string {
    const classes: Record<string, string> = {
      completed: 'status-completed',
      failed: 'status-failed',
      refunded: 'status-refunded',
      pending: 'status-pending',
    };
    return classes[status] ?? '';
  }

  confirmDeletePaymentMethod(): void {
    this.confirmationService.confirm({
      key: 'deletePaymentMethodDialog',
      header: '¿Eliminar medio de pago?',
      message:
        'Al no tener un medio de pago registrado, tu suscripción se dará de baja automáticamente en el próximo ciclo de facturación.',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Eliminar',
      rejectLabel: 'Cancelar',
      accept: () => this.deletePaymentMethod(),
    });
  }

  deletePaymentMethod(): void {
    this.isDeletingPaymentMethod = true;
    this.userService.deletePaymentMethod().subscribe({
      next: () => {
        this.paymentMethodDisplay = null;
        this.loadData();
        this.messageService.add({
          key: 'tst',
          severity: 'success',
          summary: 'Medio de pago eliminado correctamente',
        });
        this.isDeletingPaymentMethod = false;
      },
      error: () => {
        this.messageService.add({
          key: 'tst',
          severity: 'error',
          summary: 'Error al eliminar el medio de pago',
        });
        this.isDeletingPaymentMethod = false;
      },
    });
  }
}
